export default "__VITE_ASSET__BOwDZZXQ__"